import React from "react";
import FooterCTACard from "../components/FooterCTACard";
import HeroSection from "../components/pricing/HeroSection";
import PricingCards from "../components/pricing/PricingCards";


const Pricing = () => {
    return (
        <>
            {/* <Navbar pageType='inner' className={isNavbarColored ? "navbarColored" : ""} /> */}

            <div className="pt-4 wholeBody">

                <HeroSection />

                <PricingCards />

                <FooterCTACard />

            </div>

        </>
    );
};

export default Pricing;